import axios from "axios";
import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useForm } from "react-hook-form";
import { Toaster } from "react-hot-toast";
import {
  FaCheckSquare,
  FaClipboard,
  FaClipboardCheck,
  FaExternalLinkAlt,
  FaRegSquare,
} from "react-icons/fa";
// import Resizer from "react-image-file-resizer";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../logo.svg";
import {
  useAddSettingsMutation,
  useSettingsQuery,
  useUpdateSettingsMutation,
} from "../../services/settingsApi";
import Header from "../Common/Header/Header";
import SideBar from "../Common/SideBar/SideBar";
import { JwtReValidate, signInUser } from "../Utility/Auth";
import { notify } from "../Utility/Notify";
import { resolvePhotoUrl } from "../Utility/resolvePhotoUrl";
import { useUploadPhotoMutation } from "../../services/photoApi";
import PhotoUploader from "../Common/photoUpload/photoUpload";
import PackageModal from "../Common/Modal/PackageModal";
import { Link } from "react-router-dom";

const StoreSettings = () => {
  const PHOTO_BASE_URL =
    process.env.REACT_APP_PHOTO_URL || "http://localhost:5001";
  const user = signInUser() || {};
  const { aamarId, storeSettings } = user || {};
  const lang = useSelector((state) => state.languageReducer);

  console.log("USER::>>", user);
  const { data: settings, isSuccess, refetch } = useSettingsQuery(aamarId);
  const isEnableApi = Boolean(user?.package?.isEnableApi);
  const [updateSettings] = useUpdateSettingsMutation();
  const [addSettings] = useAddSettingsMutation();
  const [uploadPhoto] = useUploadPhotoMutation();
  const [file, setFile] = useState(null);
  // const [fileName, setFileName] = useState("");
  const [storePhoto, setStorePhoto] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const dispatch = useDispatch();
  const [isToggled, setIsToggled] = useState(true); // State for toggle
  const [modalVisible, setModalVisible] = useState(false);
  const closeModal = () => setModalVisible(false);
  const [isRoyaltyPoint, setIsRoyaltyPoint] = useState(true);
  const [isApiToggled, setIsApiToggled] = useState(!isEnableApi);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      invoiceIdPrefix: "AID",
      defaultInvoiceSize: "88",
      unit: "EA",
      posScreen: "pos",
      appMode: "easy",
      isPriceEditable: false,
    },
  });

  // Fetch and set settings data on success
  useEffect(() => {
    if (isSuccess && settings) {
      reset({
        ...settings,
        invoiceIdPrefix: settings?.invoiceIdPrefix || "AID",
        defaultInvoiceSize: settings?.defaultInvoiceSize || "88",
        unit: settings?.unit || "EA",
        posScreen: settings?.posScreen || "pos",
        appMode: settings?.appMode || "easy",
        isPriceEditable: Boolean(settings?.isPriceEditable),
      });
      const rawPhoto = settings?.storePhoto || settings?.photo;
      if (rawPhoto) {
        const resolved = resolvePhotoUrl(rawPhoto);
        setStorePhoto(resolved);
        setValue("storePhoto", resolved);
        setValue("photo", resolved);
      } else {
        const defaultLogo = "/uploads/setting/aamarDokan.png";
        const resolved = resolvePhotoUrl(defaultLogo);
        setStorePhoto(resolved);
        setValue("storePhoto", resolved);
        setValue("photo", resolved);
      }
    }
  }, [isSuccess, settings, reset, setValue]);

  // Handle form submission
  const onSubmit = async (data, message) => {
    const currentPhoto = storePhoto || settings?.storePhoto || settings?.photo;
    const payload = {
      ...data,
      invoiceIdPrefix: (data?.invoiceIdPrefix || "AID").toUpperCase(),
      aamarId: aamarId,
      isPriceEditable:
        data?.isPriceEditable !== undefined
          ? Boolean(data.isPriceEditable)
          : Boolean(settings?.isPriceEditable),
      paymentMethods: settings?.paymentMethods || [],
      ...(currentPhoto ? { storePhoto: currentPhoto, photo: currentPhoto } : {}),
    };
    // console.log("Payload for submission:", data);
    const response = await addSettings(payload);
    // console.log("Response", response);
    if (response?.data) {
      await JwtReValidate();

      refetch();
      notify(message, "success");
    } else {
      const errMessage =
        response?.error?.data?.message ||
        response?.error?.message ||
        "Failed to add settings.";
      notify(errMessage, "error");
    }
  };

  const handlePriceEditToggle = async (e) => {
    const nextVal = e.target.checked;
    setValue("isPriceEditable", nextVal);
    const currentPhoto = storePhoto || settings?.storePhoto || settings?.photo;
    const payload = {
      ...settings,
      ...getValues(),
      isPriceEditable: nextVal,
      invoiceIdPrefix: (getValues("invoiceIdPrefix") || settings?.invoiceIdPrefix || "AID").toUpperCase(),
      aamarId: aamarId,
      paymentMethods: settings?.paymentMethods || [],
      ...(currentPhoto ? { storePhoto: currentPhoto, photo: currentPhoto } : {}),
    };
    const response = await addSettings(payload);
    if (response?.data) {
      await JwtReValidate();
      refetch();
      notify(
        nextVal
          ? "Price edit in POS enabled!"
          : "Price edit in POS disabled!",
        "success"
      );
    } else {
      notify("Failed to update price edit setting.", "error");
    }
  };

  const handleToggleChange = () => {
    setIsToggled(!isToggled);
  };
  const handleRoyaltyPointChange = () => {
    setIsRoyaltyPoint(!isRoyaltyPoint);
  };
  // const handleApiChange = () => {
  //   setIsApiToggled(!isApiToggled);
  // };

  const updatePhotUrl = async (url) => {
    const cleanUrl = resolvePhotoUrl(url);
    setStorePhoto(cleanUrl);
    setValue("storePhoto", cleanUrl);
    setValue("photo", cleanUrl);
    const payload = {
      storePhoto: cleanUrl,
      photo: cleanUrl,
      aamarId: aamarId,
    };
    // console.log("Payload for submission:", data);
    const response = await addSettings(payload);
    // console.log("Response", response);
    if (response?.data) {
      await JwtReValidate();
      refetch();
      notify("Logo Upload Successful", "success");
    } else {
      notify("Failed to add settings.", "error");
    }
  };

  // E-Commerce API Toggle
  const handleToggleAttempt = (e) => {
    if (!isEnableApi) {
      setModalVisible(true);
      return;
    }

    const newValue = !isApiToggled;
    setIsApiToggled(newValue);
    setValue("isEnableApi", newValue); // Update the form value
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-2">
          <SideBar />
        </div>
        <div className="col-md-10">
          <Header title={lang?.storeSettings} />
          <div className="row mt-3">
            <div className="col-md-3" />
            <div className="col-md-6 mt-5 ">
              <div className="mb-4">
                <h5 className="mb-3 d-flex align-content-center gap-2">
                  <Icons.HomeOutline /> {lang?.storeLogo}
                </h5>
                <hr />

                {/* <PhotoUploader bucket={aamarId} onSuccess={updatePhotUrl} /> */}
                <PhotoUploader
                  uploadSuccess={updatePhotUrl}
                  aspectRatio={8 / 2}
                  folderName={aamarId}
                  maxFileSize={1 * 1024 * 1024} // 1MB
                  acceptedFileTypes={[
                    "image/jpg",
                    "image/jpeg",
                    "image/svg",
                    "image/png",
                    "image/webp",
                  ]}
                  image={storePhoto || settings?.storePhoto || settings?.photo || null}
                  placeholder={logo}
                />
                {/* Basic Section */}
              </div>
              <form
                style={{ marginTop: "80px" }}
                onSubmit={handleSubmit((data) =>
                  onSubmit(data, "Basic Settings added successfully!")
                )}
              >
                <div className="mb-4">
                  <h5 className="mb-3 d-flex align-content-center gap-2">
                    <Icons.UserOutline /> {lang?.basicInfo}
                  </h5>
                  <hr />

                  <div className="row mb-2">
                    <label className="col-sm-4 col-form-label">
                      Store Name
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className="form-control"
                        {...register("storeName")}
                        placeholder="Store Name"
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <label className="col-sm-4 col-form-label">
                      Business Type
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className="form-control"
                        {...register("businessType")}
                        placeholder="Business Type"
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-sm-6">
                      <label className="col-form-label"> License Number</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("licenseNumber")}
                        placeholder="License Number"
                      />
                    </div>
                    <div className="col-sm-6">
                      <label className="col-form-label">Currency</label>
                      <div className="input-group">
                        <select
                          className="form-select"
                          {...register("currency")}
                        >
                          <option value="BDT">BDT</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end mt-4">
                    <button type="submit" className="btn btn-dark">
                      <Icons.SaveOutline className="me-2" />
                      Save Basic
                    </button>
                  </div>
                </div>
              </form>

              {/* Contact Info Section */}
              <form
                style={{ marginTop: "80px" }}
                onSubmit={handleSubmit((data) =>
                  onSubmit(data, "Contact Settings added successfully!")
                )}
              >
                <div className="mb-4">
                  <h5 className="mb-3 d-flex align-content-center gap-2 mt-5">
                    <Icons.UserOutline />
                    {lang?.contactInfo}
                  </h5>
                  <hr />
                  <div className="row mb-2">
                    <label className="col-sm-4 col-form-label">Email</label>
                    <div className="col-sm-8">
                      <input
                        type="email"
                        className="form-control"
                        {...register("email")}
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <label className="col-sm-4 col-form-label">Phone</label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className="form-control"
                        {...register("phone")}
                        placeholder="Phone"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <label className="col-sm-4 col-form-label">Website</label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className="form-control"
                        {...register("websiteUrl")}
                        placeholder="Website URL"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <label className=" col-form-label">Address</label>
                    <div className="col-sm-12">
                      <input
                        type="text"
                        className="form-control"
                        {...register("address.street")}
                        placeholder="Street Address"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-sm-6">
                      <label className="col-form-label">City</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("address.city")}
                        placeholder="City"
                      />
                    </div>
                    <div className="col-sm-6">
                      <label className="col-form-label">State</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("address.state")}
                        placeholder="State"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div
                      className="col-sm-4
                    "
                    >
                      <label className="col-form-label">Postal Code</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("address.post")}
                        placeholder="Post Code"
                      />
                    </div>
                    <div
                      className="col-sm-4
                    "
                    >
                      <label className="col-form-label">Zip Code</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("address.zip")}
                        placeholder="Zip Code"
                      />
                    </div>
                    <div
                      className="col-sm-4
                    "
                    >
                      <label className="col-form-label">Country</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("address.country")}
                        placeholder="Country"
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-end mt-4">
                    <button type="submit" className="btn btn-dark">
                      <Icons.SaveOutline className="me-2" />
                      Save Contact
                    </button>
                  </div>
                </div>
              </form>

              {/* POS Settings Section */}
              <form
                style={{ marginTop: "80px" }}
                onSubmit={handleSubmit(
                  (data) => onSubmit(data, "POS Settings added successfully!"),
                  (formErrors) => {
                    console.error("POS Settings form errors:", formErrors);
                    const firstError =
                      Object.values(formErrors)[0]?.message ||
                      "Please check the form for errors.";
                    notify(firstError, "error");
                  }
                )}
              >
                <div className="mb-4">
                  <h5 className="mb-3 d-flex align-content-center gap-2 mt-5">
                    <Icons.UserOutline />
                    {lang?.posSettings}
                  </h5>
                  <hr />
                  <div className="row mb-2">
                    <label className="col-sm-4 col-form-label">
                      Invoice Prefix
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className="form-control"
                        {...register("invoiceIdPrefix", {
                          maxLength: {
                            value: 10,
                            message: "Please enter no more than 10 characters",
                          },
                          onChange: (e) => {
                            const upper = e.target.value.toUpperCase();
                            e.target.value = upper;
                            setValue("invoiceIdPrefix", upper);
                          },
                        })}
                        placeholder="Invoice Prefix"
                        style={{ textTransform: "uppercase" }}
                      />
                    </div>
                    {errors?.invoiceIdPrefix?.message && (
                      <div className="text-danger">
                        {errors.invoiceIdPrefix.message}
                      </div>
                    )}
                  </div>

                  <div className="row mb-2">
                    <div className="col-sm-6">
                      <label className="col-form-label">Invoice Size</label>
                      <div className="">
                        <div className="input-group">
                          <select
                            className="form-select"
                            {...register("defaultInvoiceSize")}
                          >
                            <option value="88">88 cm</option>
                            <option value="85">85 cm</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <label className="col-form-label">Unit</label>
                      <div className="input-group">
                        <select className="form-select" {...register("unit")}>
                          <option value="EA">
                            <span role="img" aria-label="each">
                              {" "}
                              (Each)
                            </span>
                          </option>
                          <option value="Number">
                            <span role="img" aria-label="number">
                              🔢 Number
                            </span>
                          </option>
                          <option value="Float">
                            <span role="img" aria-label="float">
                              💧 Float
                            </span>
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <label className="col-form-label">POS Screen</label>
                      <div className="">
                        <div className="input-group">
                          <select
                            className="form-select"
                            {...register("posScreen")}
                          >
                            <option value="pos">🔒 Secure POS</option>
                            <option value="pos2">🔓 Unsecured POS</option>
                            <option value="pos3">🔓 POS 3</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <label className="col-form-label">Application Mode</label>
                      <div className="">
                        <div className="input-group">
                          <select
                            className="form-select"
                            {...register("appMode")}
                          >
                            <option value="easy" className="bg-">
                              {" "}
                              🟢 Easy Mode
                            </option>
                            <option value="medium">🟠 Medium Mode</option>
                            <option value="advanced">🔴 Advanced Mode</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-3 mt-3 align-items-center">
                    <div className="col-sm-8">
                      <label
                        htmlFor="isPriceEditableToggle"
                        className="col-form-label fw-bold d-block"
                        style={{ cursor: "pointer" }}
                      >
                        Price Edit in POS
                      </label>
                      <small
                        className="text-muted d-block"
                        style={{ fontSize: "12px", marginTop: "-4px" }}
                      >
                        Enable or disable price input field, batch dropdown, and MRP / TP toggle in /pos
                      </small>
                    </div>
                    <div className="col-sm-4 d-flex justify-content-sm-end align-items-center mt-2 mt-sm-0">
                      <div className="form-check form-switch fs-5 mb-0">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="isPriceEditableToggle"
                          checked={Boolean(watch("isPriceEditable"))}
                          onChange={handlePriceEditToggle}
                        />
                        <label
                          htmlFor="isPriceEditableToggle"
                          className="form-check-label fs-6 ms-2 align-middle fw-semibold"
                          style={{
                            cursor: "pointer",
                            color: watch("isPriceEditable") ? "#198754" : "#6c757d",
                          }}
                        >
                          {watch("isPriceEditable") ? "Enabled" : "Disabled"}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-end mt-4">
                    <button type="submit" className="btn btn-dark">
                      <Icons.SaveOutline className="me-2" />
                      Save POS
                    </button>
                  </div>
                </div>
              </form>
              {/* VAT Settings Section */}
              <form
                style={{ marginTop: "80px" }}
                onSubmit={handleSubmit((data) =>
                  onSubmit(data, "VAT Settings added successfully!")
                )}
              >
                <div className="mb-4">
                  <div className="d-flex justify-content-between">
                    <h5 className=" d-flex align-content-center gap-2">
                      <Icons.UserOutline />
                      {lang?.vatTaxAmount}
                    </h5>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="vatTaxToggle"
                        checked={!isToggled}
                        onChange={handleToggleChange}
                      />
                      <label
                        htmlFor="vatTaxToggle"
                        className="form-check-label"
                      >
                        {!isToggled ? "Enabled" : "Disabled"}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row mb-2">
                    <label className="col-sm-4 col-form-label">
                      BIN Number
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className="form-control"
                        {...register("binNumber")}
                        placeholder="BIN Number"
                        disabled={isToggled} // Disable if toggle is off
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <label className="col-sm-4 col-form-label">
                      VAT Percentage
                    </label>
                    <div className="col-sm-8">
                      <div className="input-group">
                        <input
                          type="number"
                          className="form-control"
                          {...register("vatPercentage")}
                          placeholder="VAT Percentage"
                          disabled={isToggled} // Disable if toggle is off
                        />
                        <span className="input-group-text p-2">%</span>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end mt-4">
                    <button
                      type="submit"
                      className="btn btn-dark"
                      disabled={isToggled}
                    >
                      <Icons.SaveOutline className="me-2" />
                      Save VAT
                    </button>
                  </div>
                </div>
              </form>
              {/* E-commerce api and  Section */}
              <form
                style={{ marginTop: "80px" }}
                onSubmit={handleSubmit((data) =>
                  onSubmit(data, "E-commerce Settings added successfully!")
                )}
              >
                {/* <fieldset> */}
                <div className="mb-4">
                  <div className="d-flex justify-content-between">
                    <h5 className="d-flex align-content-center gap-2">
                      <i className="icon-user-outline" />
                      E-Commerce API
                    </h5>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="ecommerceToggle"
                        checked={!isApiToggled}
                        onChange={handleToggleAttempt}
                      />
                      <label
                        htmlFor="ecommerceToggle"
                        className="form-check-label"
                      >
                        {!isApiToggled ? "Enabled" : "Disabled"}
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="mt-3">
                    {!isApiToggled ? (
                      <span>
                        Now, go ahead and configure your E‑commerce store
                        <Link to="/eCommerceStoreSetup">Settings</Link>
                      </span>
                    ) : (
                      <p
                        className="text-muted"
                        style={{
                          opacity: 0.5,
                          pointerEvents: "none",
                          userSelect: "none",
                        }}
                      >
                        Now, go ahead and configure your e‑commerce store{" "}
                        <span className="text-danger">Settings</span>
                      </p>
                    )}
                  </div>
                </div>
                {/* </fieldset> */}
              </form>

              {/* Loyalty Point Settings Section */}
              <form
                style={{ marginTop: "80px" }}
                onSubmit={handleSubmit((data) =>
                  onSubmit(data, "Loyalty Point Settings added successfully!")
                )}
              >
                <div className="mb-4">
                  <div className="d-flex justify-content-between ">
                    <h5 className=" d-flex align-content-center gap-2">
                      <Icons.UserOutline />
                      {lang?.LoyaltyPointSettings}
                    </h5>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="royaltyPointToggle"
                        checked={!isRoyaltyPoint}
                        onChange={handleRoyaltyPointChange}
                      />
                      <label
                        htmlFor="royaltyPointToggle"
                        className="form-check-label"
                      >
                        {!isRoyaltyPoint ? "Enabled" : "Disabled"}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="mb-2 col-md-3">
                      <label className=" ">Amount</label>
                      <div className="">
                        <input
                          type="text"
                          className="form-control"
                          {...register("royaltyAmount")}
                          placeholder="Royalty Amount"
                          disabled={isRoyaltyPoint} // Disable if toggle is off
                        />
                      </div>
                    </div>
                    <div className="mb-2 col-md-7">
                      <label className=" "></label>
                      <div className="">
                        <span>
                          The customer will receive points based on the amount.
                        </span>{" "}
                        <input
                          type="hidden"
                          {...register("royaltyPoint")}
                          value={1}
                        />
                      </div>
                    </div>
                    <div className="mb-2 col-md-2 justify-content-end">
                      <label className=""></label>
                      <div className="">
                        <div className="input-group">
                          <span className="fw-bold">Point: 1</span>{" "}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-end mt-4">
                    <button
                      type="submit"
                      className="btn btn-dark"
                      disabled={isRoyaltyPoint}
                    >
                      <Icons.SaveOutline className="me-2" />
                      Save Royalty Point
                    </button>
                  </div>
                </div>
              </form>


            </div>
          </div>
        </div>
      </div>
      <Toaster position="bottom-right" />
      {/* Package Info Modal */}
      <PackageModal show={modalVisible} handleClose={closeModal} />{" "}
    </div>
  );
};

export default StoreSettings;
